import React, { PropsWithChildren } from 'react';
import { UserApplicationRole } from '../../constants';
import {
  ApolloClientsProvider,
  ApolloClientsProviderProps,
} from '../ApolloClientsProvider';
import { AuthContext } from '../AuthTokenContext';
import { ConfigContext } from '../ConfigContext';
import { RoleGuardProvider } from '../RoleGuardContext';

export interface GlobalContextProps
  extends PropsWithChildren<ApolloClientsProviderProps> {
  requiredRoles?: UserApplicationRole[];
}

export function GlobalContext({
  children,
  clientSpecifiers,
  requiredRoles = [],
}: GlobalContextProps) {
  return (
    <ConfigContext.Provider>
      <AuthContext>
        <ApolloClientsProvider clientSpecifiers={clientSpecifiers}>
          <RoleGuardProvider requiredRoles={requiredRoles}>
            {children}
          </RoleGuardProvider>
        </ApolloClientsProvider>
      </AuthContext>
    </ConfigContext.Provider>
  );
}
